module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "size": "lg",
      "id": "ModalShipOrder",
      "hide-footer": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-header": "",
      "centered": ""
    }
  }, [(_vm.action.action === 'editShipOrder') ? _c('EditShipOrder', {
    attrs: {
      "action": _vm.action
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77c00e92","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/modal/ModalShipOrder.vue
// module id = 3277
// module chunks = 0